import { render, staticRenderFns } from "./alarms-modal.vue?vue&type=template&id=8709b65c&"
import script from "./alarms-modal.ts?vue&type=script&lang=ts&"
export * from "./alarms-modal.ts?vue&type=script&lang=ts&"
import style0 from "./alarms-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports